import { type RouteRecordRaw } from 'vue-router'

import { useSponsorsStore } from './sponsors.store'

export const SponsorsRouter: RouteRecordRaw[] = [
  {
    path: '/sponsors',
    component: async () => import('./Sponsors.vue'),
  },
  {
    path: '/sponsors/create',
    component: async () => import('./AddingSponsors.vue'),
  },
  {
    path: '/sponsors/:id',
    component: async () => import('./AddingSponsors.vue'),
    async beforeEnter(to) {
      await useSponsorsStore.getState().loadSponsor(to.params.id as string)
    },
  },
]
